import universal from 'react-universal-component';
import { LoadingComponent } from '../../components/LoadingComponent';
import React from 'react';

export default universal(import('./CheatSheets'), {loading: <LoadingComponent />});



// WEBPACK FOOTER //
// ./src/app/views/CheatSheets/index.js